export const ROUTE_DEVIATIONS = 'trafikkmeldinger';
export const ROUTE_RTV = 'rtv';
export const ROUTE_SETTINGS = 'settings';
export const ROUTE_404 = 'not-found';
export const ROUTE_TRAIN_CARD = 'train-card';

// Routes to be intercepted
export const ROUTE_ORDER_REDIRECT = 'o/:orderId';
export const ROUTE_TRAIN_CARD_REDIRECT = 'tog/:serviceId';
